// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
Vue.use(VueSweetalert2);

import 'bootstrap'
require('bootstrap/dist/css/bootstrap.css')
import 'linearicons'
import 'select2'
import './assets/app.sass'
import './assets/login.sass'
import './assets/util.sass'

import {store} from './store/index.js'

Vue.config.productionTip = false

/*window.serverUrl = "http://dev.tracketiza.com/wservice/mobile.php"
window.apiUrl = "http://dev-api.tracketiza.com/api"*/

window.serverUrl = "https://admin.tracketiza.com/wservice/mobile.php"
window.apiUrl = "https://api.tracketiza.com/api"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js